var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ionicon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"32","d":"M256 112v288M400 256H112"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }